export const queryKeys = {
    applications: (status, locationRef) => ['applications', status, locationRef],
    application: (ref) => ['applications', 'detail', ref],
    locations: () => ['locations'],
};
